var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-error-detail"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("错题详情")]),_c('p',[_vm._v("错题ID: "+_vm._s(_vm.$route.params.id))]),_c('p',[_vm._v("家长端错题详情页面，开发中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }